var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7556 52.4111L75.3778 35.3445L58.3111 53.8333L5.33334 70.9L22.7556 52.4111Z",
    fill: "#D1D1D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7556 128.856L75.3778 111.789V35.7L22.7556 52.4111V128.856Z",
    fill: "#D1D1D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.6 48.8556L75.3778 35.7L94.9333 54.5444L157.156 67.7L137.6 48.8556Z",
    fill: "#D1D1D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.956 125.3L75.3778 112.144V35.7L137.956 48.8556V125.3Z",
    fill: "#DCDDE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 142.011L137.956 124.944V48.8556L85.3333 65.9222V142.011Z",
    fill: "#D1D1D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 89.7444L153.956 72.6778L137.956 48.5L85.3333 65.9222L101.333 89.7444Z",
    fill: "#EFEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 142.011L22.7556 128.856V52.4111L85.3333 65.9222V142.011Z",
    fill: "#DCDDE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95555 76.2333L22.7556 52.4111L85.3333 65.9222L72.1778 89.3889L9.95555 76.2333Z",
    fill: "#EFEFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3556 33.2111C64 33.2111 63.6444 32.8556 63.2889 32.8556L58.3111 26.1C57.9556 25.3889 57.9556 24.6778 58.6667 24.3222C59.3778 23.9667 60.0889 23.9667 60.4444 24.6778L65.4222 31.4333C65.7778 32.1445 65.7778 32.8556 65.0667 33.2111C65.0667 33.2111 64.7111 33.2111 64.3556 33.2111Z",
    fill: "#DCDDE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7556 33.2111C86.4 33.2111 86.0444 33.2111 86.0444 32.8556C85.3333 32.5 84.9778 31.7889 85.6889 31.0778L90.6667 24.3222C91.0222 23.6111 92.0889 23.6111 92.4444 23.9667C93.1556 24.3222 93.1556 25.3889 92.8 25.7445L87.8222 32.5C87.4667 32.8556 87.1111 33.2111 86.7556 33.2111Z",
    fill: "#DCDDE0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3778 28.9444C74.6667 28.9444 73.9556 28.2333 73.9556 27.5222V18.9889C73.9556 18.2778 74.6667 17.5667 75.3778 17.5667C76.0889 17.5667 76.8 18.2778 76.8 18.9889V27.8778C76.8 28.2333 76.0889 28.9444 75.3778 28.9444Z",
    fill: "#DCDDE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox2);
export default __webpack_public_path__ + "static/media/empty_box2.6de71e46253c52621b13189fa9a64ff7.svg";
export { ForwardRef as ReactComponent };